export default __webpack_public_path__ + "static/case-study-1-aa7d37e832035ee32aa92cf8acc9e779.webp";